'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _toArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toArray");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var errCode = require('err-code');

var mergeOpts = require('merge-options');

var cid = require('multiformats/cid');

var PeerId = require('peer-id');

var isDomain = require('is-domain-name');

var toString = require('uint8arrays/to-string');

var utils = require('../../utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var isDomain__default = /*#__PURE__*/_interopDefaultLegacy(isDomain);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = Object.assign(debug__default["default"]('ipfs:name:resolve'), {
  error: debug__default["default"]('ipfs:name:resolve:error')
});

var appendRemainder = function appendRemainder(result, remainder) {
  return remainder.length > 0 ? result + '/' + remainder.join('/') : result;
};

function createResolve(_ref) {
  var dns = _ref.dns,
      ipns = _ref.ipns,
      peerId = _ref.peerId,
      isOnline = _ref.isOnline,
      offline = _ref.options.offline;

  function resolve(_x) {
    return _resolve.apply(this, arguments);
  }

  function _resolve() {
    _resolve = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name) {
      var options,
          _name$slice$split,
          _name$slice$split2,
          namespace,
          hash,
          remainder,
          value,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              options = mergeOptions({
                nocache: false,
                recursive: true
              }, options);

              if (!(offline && options && options.nocache)) {
                _context.next = 4;
                break;
              }

              throw errCode__default["default"](new Error('cannot specify both offline and nocache'), 'ERR_NOCACHE_AND_OFFLINE');

            case 4:
              if (!name) {
                name = peerId.toB58String();
              }

              if (!name.startsWith('/ipns/')) {
                name = "/ipns/".concat(name);
              }

              _name$slice$split = name.slice(1).split('/'), _name$slice$split2 = _toArray(_name$slice$split), namespace = _name$slice$split2[0], hash = _name$slice$split2[1], remainder = _name$slice$split2.slice(2);
              _context.prev = 7;

              if (hash.substring(0, 1) === '1') {
                PeerId__default["default"].parse(hash);
              } else {
                cid.CID.parse(hash);
              }

              _context.next = 24;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](7);

              if (!isDomain__default["default"](hash)) {
                _context.next = 22;
                break;
              }

              _context.t1 = appendRemainder;
              _context.next = 17;
              return _awaitAsyncGenerator(dns(hash, options));

            case 17:
              _context.t2 = _context.sent;
              _context.t3 = remainder;
              _context.next = 21;
              return (0, _context.t1)(_context.t2, _context.t3);

            case 21:
              return _context.abrupt("return");

            case 22:
              log.error(_context.t0);
              throw errCode__default["default"](new Error('Invalid IPNS name'), 'ERR_IPNS_INVALID_NAME');

            case 24:
              if (!(!isOnline() && !offline)) {
                _context.next = 26;
                break;
              }

              throw errCode__default["default"](new Error(utils.OFFLINE_ERROR), 'OFFLINE_ERROR');

            case 26:
              _context.next = 28;
              return _awaitAsyncGenerator(ipns.resolve("/".concat(namespace, "/").concat(hash), options));

            case 28:
              value = _context.sent;
              _context.next = 31;
              return appendRemainder(value instanceof Uint8Array ? toString.toString(value) : value, remainder);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 11]]);
    }));
    return _resolve.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(resolve);
}

exports.createResolve = createResolve;